import React from 'react';
import { CraConditionScores } from '../../../../../common/src/enums/CraConditionScores';
import { useTranslate } from '../../../mixins/translate/translate';

export function CraCondition(props: { conditionScore?: CraConditionScores | undefined | null }) {
    const translate = useTranslate();
    switch (props.conditionScore) {
        case CraConditionScores.LowRisk:
            return (
                <span className="label cra1 p5 fs11" style={{ color: '#FFFFFF' }}>
                    {translate('cra.riskScore1')}
                </span>
            );
        case CraConditionScores.BelowAverageRisk:
            return (
                <span className="label cra2 p5 fs11" style={{ color: '#FFFFFF' }}>
                    {translate('cra.riskScore2')}
                </span>
            );
        case CraConditionScores.AboveAverageRisk:
            return (
                <span className="label cra3 p5 fs11" style={{ color: '#FFFFFF' }}>
                    {translate('cra.riskScore3')}
                </span>
            );
        case CraConditionScores.HighRisk:
            return (
                <span className="label cra4 p5 fs11" style={{ color: '#FFFFFF' }}>
                    {translate('cra.riskScore4')}
                </span>
            );

        // case CraConditionScores.LowRisk: return <div className="rams1" style={{ width: '100%', color: 'white', padding: '5px' }}>{translate('cra.riskScore1')}</div>;
        // case CraConditionScores.BelowAverageRisk: return <div className="rams2" style={{ width: '100%', color: 'white', padding: '5px' }}>{translate('cra.riskScore2')}</div>;
        // case CraConditionScores.AboveAverageRisk: return <div className="rams3" style={{ width: '100%', color: 'white', padding: '5px' }}>{translate('cra.riskScore3')}</div>;
        // case CraConditionScores.HighRisk: return <div className="rams4" style={{ width: '100%', color: 'white', padding: '5px' }}>{translate('cra.riskScore4')}</div>;

        default:
            // return <div style={{ width: '100%', backgroundColor: '#3498db', color: 'white', padding: '5px' }}>{translate('cra.riskScore0')}</div>;
            return (
                <span className="label cra-unknown p5 fs11" style={{ color: '#FFFFFF' }}>
                    {translate('cra.riskScore0')}
                </span>
            );

        // return <span className="label rams-unknown p5 fs11" style={{ color: '#FFFFFF' }}>{translate('cra.riskScore0')}</span>;
    }
}
